import type { KeyPoseGhostMaterialVariant } from './types';

interface KeyPoseGhostMaterialVariantOption {
  description: string;
  label: string;
  value: KeyPoseGhostMaterialVariant;
}

export const DEFAULT_KEY_POSE_GHOST_MATERIAL_VARIANT =
  'flatTint' satisfies KeyPoseGhostMaterialVariant;

export const KEY_POSE_GHOST_MATERIAL_VARIANT_OPTIONS = [
  {
    value: 'flatTint',
    label: 'Flat tint',
    description: 'Previous grey-scale key pose ghost style.',
  },
  {
    value: 'texturedTransparent',
    label: 'Textured transparent',
    description: 'Single-pass textured ghost from the staged version.',
  },
  {
    value: 'texturedShell',
    label: 'Textured shell',
    description: 'Depth-shell textured ghost with reduced overlap noise.',
  },
] satisfies readonly KeyPoseGhostMaterialVariantOption[];

export function isKeyPoseGhostMaterialVariant(
  value: string,
): value is KeyPoseGhostMaterialVariant {
  return KEY_POSE_GHOST_MATERIAL_VARIANT_OPTIONS.some(
    (option) => option.value === value,
  );
}
